var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.progressClasss },
    [
      _vm.isSide(["start"]) ? _c("progress-side") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mku-progress__outer", style: _vm.outerStyle }, [
        _c(
          "div",
          { staticClass: "mku-progress__inner", style: _vm.innerStyle },
          [
            _c("span", { class: _vm.shadowClasss, style: _vm.shadowStyle }),
            _vm._v(" "),
            _vm.isSide(["start-inside", "end-inside", "top-follow"])
              ? _c("progress-side")
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.isSide(["end"]) ? _c("progress-side") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }